/**
 * This is a reducer for everything related to notifications
 */
import { RaceActionsTypes } from './race-actions';
import { CountByStateResult, Planning, Race } from '../../api/model';
import initialState from '../../initialState';
import { LoadedSingleResource, LoadedResource } from '../StoreModel';
import StoreModel from '../StoreModel';


export interface IRaceStore {
    resume: LoadedResource<CountByStateResult>;

    byId: {
        [k: string]: LoadedSingleResource<Race>
    };

    byState: {
        [k: string]: LoadedResource<Race>
    };

    current: LoadedSingleResource<Race>;

    all: LoadedResource<Race>;

    allPlanning: LoadedResource<Planning>;

    imageFile: LoadedSingleResource<any>;

    deletePlanning?: LoadedSingleResource<void>;
}

export default (state = initialState.race, action?: any): IRaceStore => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case RaceActionsTypes.RESUME_FETCH:
            return { ...state, resume: StoreModel.fetching() };

        case RaceActionsTypes.RESUME_ERROR:
            return { ...state, resume: StoreModel.error(action.payload) };

        case RaceActionsTypes.RESUME_RESULT:
            return { ...state, resume: StoreModel.result(action.payload) };

        case RaceActionsTypes.ALL_FETCH:
            return { ...state, all: StoreModel.fetching() };

        case RaceActionsTypes.ALL_ERROR:
            return { ...state, all: StoreModel.error(action.payload) };

        case RaceActionsTypes.ALL_RESULT:
            return { ...state, all: StoreModel.result(action.payload) };

        case RaceActionsTypes.BY_STATE_FETCH:
            return {
                ...state,
                byState: {
                    ...state.byState,
                    [action.state]: { fetching: true, }
                }
            };

        case RaceActionsTypes.SINGLE_FETCH:
            return {
                ...state,
                byId: { [action.payload.id]: StoreModel.fetchingSingle() }
            }

        case RaceActionsTypes.SINGLE_RESULT:
            return {
                ...state,
                byId: { [action.payload.id]: StoreModel.resultSingle(action.payload.data) }
            }

        case RaceActionsTypes.SINGLE_ERROR:
            return {
                ...state,
                byId: { [action.payload.id]: StoreModel.errorSingle(action.payload.err) }
            }

        case RaceActionsTypes.BY_STATE_RESULT:
            return {
                ...state,
                byState: {
                    ...state.byState,
                    [action.state]: { fetching: false, data: action.payload }
                }
            };

        case RaceActionsTypes.BY_STATE_ERROR:
            return {
                ...state,
                byState: {
                    ...state.byState,
                    [action.state]: { fetching: false, err: action.payload }
                }
            };

        case RaceActionsTypes.REQUEST_ADD:
            return { ...state, current: StoreModel.fetchingSingle() };

        case RaceActionsTypes.RESULT_ADD:
            return { ...state, current: StoreModel.resultSingle(action.payload) };

        case RaceActionsTypes.ERROR_ADD:
            return { ...state, current: StoreModel.errorSingle(action.payload) };

        case RaceActionsTypes.RACE_GET_FILES_REQUEST: {
            return {
                ...state,
                imageFile: StoreModel.fetchingSingle()
            }
        }
        case RaceActionsTypes.RACE_GET_FILES_RESPONSE: {
            return {
                ...state,
                imageFile: StoreModel.resultSingle(action.payload)
            }
        }
        case RaceActionsTypes.RACE_GET_FILES_ERROR: {
            return {
                ...state,
                imageFile: StoreModel.errorSingle(action.payload)
            }
        }

        case RaceActionsTypes.ALL_PLANNING:
            return { ...state, allPlanning: StoreModel.fetching() };

        case RaceActionsTypes.ALL_PLANNING_ERROR:
            return { ...state, allPlanning: StoreModel.error(action.payload) };
        case RaceActionsTypes.ALL_PLANNING_RESULT:
            return { ...state, allPlanning: StoreModel.result(action.payload) };

        case RaceActionsTypes.DELETE_PLANNING:
            return {
                ...state,
                deletePlanning: StoreModel.fetchingSingle()
            };

        case RaceActionsTypes.DELETE_PLANNING_ERROR:
            return {
                ...state,
                deletePlanning: StoreModel.errorSingle(action.payload)
            };

        case RaceActionsTypes.DELETE_PLANNING_RESULT:
            return {
                ...state,
                deletePlanning: StoreModel.resultSingle(action.payload)
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/race/race-reducer.ts